import qs from "query-string";

import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import CaseNotesModel from "../../models/case-notes";

const getNotesPath = (settlementId, params = {}) => {
  const queryString = qs.stringify(params);
  const path = `settlement/${settlementId}/notes/`;

  return queryString ? `${path}?${queryString}` : path;
};

export default class SettlementNotesRepository extends BaseRepository {
  static modelClass = CaseNotesModel;
  modelName = "case-notes";

  async query(settlementId, params = {}) {
    return super.query({ urlPath: getNotesPath(settlementId, params) });
  }

  async createRecord(settlementId, data) {
    return super.post(data, {
      urlPath: `settlement/${settlementId}/add_note/`,
    });
  }

  async patch(noteId, data, settlementId) {
    return super.patch("", data, {
      urlPath: `settlement/${settlementId}/update_note/${noteId}/`,
    });
  }

  async delete(noteId, settlementId) {
    return super.delete("", {
      urlPath: `settlement/${settlementId}/delete_note/${noteId}/`,
    });
  }
}
